export default class StringViewModel {
    name: string;
    value: string;

    public constructor(name: string, value: string) {
        this.name = name;
        this.value = value;
    }
}